import axios from "axios";
import { create } from "zustand";

const initialState = {
  loading: false,
  success: false,
  error: false,
  errorData: null,
  products: null,
  formatted_string: null,
  shouldUseBundleTitle: false,
  emailMarketingConfig: null,

  // subscription support
  original_products: null,
  subscription: null,
};

const mergeSubscriptionProducts = (original = [], subs = []) => {
  if (!Array.isArray(original) || !Array.isArray(subs)) return original;

  const subByAmount = new Map(subs.map((sp) => [sp.amount, sp]));

  return original.map((product) => {
    const subProduct = subByAmount.get(product.amount);
    if (!subProduct) return product;

    return {
      ...product,
      bundle_products: subProduct.bundle_products,
      display_name: subProduct.display_name,
      amount: subProduct.amount,
      billed_amount: subProduct.billed_amount,
      price: subProduct.price,
      shipping_price: subProduct.shipping_price,
      old_price: subProduct.old_price,
      you_save_percentage: subProduct.you_save_percentage,
      image: subProduct.image || product.image,
      tr_bundle_products: subProduct.tr_bundle_products || product.tr_bundle_products,
    };
  });
};

export const useProductData = create((set, get) => ({
  ...initialState,
  get: async ({ postId, isMobile, affParam }) => {
    set({ ...initialState, loading: true });
    try {
      const res = await axios.post("/wp-json/core/products/v1/product_pack", {
        postId,
        isMobile,
        affParam,
      });
      const productSettings = res?.data.products;
      const shouldUseBundleTitle = productSettings?.show_bundle_design || productSettings?.show_product_picker_v2;

      // subscription support
      const originalProducts = productSettings?.products || [];
      const subscription = productSettings?.subscription || null;
      const subscriptionProducts = subscription?.products || null;

      let products = originalProducts;

      const acfSubscribe = !!(subscription && subscription.subscription_enable);
      if (acfSubscribe && Array.isArray(subscriptionProducts)) {
        products = mergeSubscriptionProducts(originalProducts, subscriptionProducts);
      }

      set({
        ...initialState,
        ...productSettings,
        success: true,
        products,
        original_products: originalProducts,
        subscription,
        formatted_string: res?.data.formatted_string,
        country_code: res?.data?.country?.toUpperCase(),
        shouldUseBundleTitle: shouldUseBundleTitle,
        paymentsConfig: res?.data?.paymentsConfig,
        emailMarketingConfig: res?.data?.emailMarketingConfig,
      });
    } catch (err) {
      set({ ...initialState, error: true, errorData: err.message });
    }
  },

  setProductsBySubscription: (isSubscribe) => {
    const s = get();

    if (!Array.isArray(s.original_products)) return;

    if (isSubscribe && Array.isArray(s.subscription?.products)) {
      const updated = mergeSubscriptionProducts(s.original_products, s.subscription?.products);
      set({ products: updated });
    } else {
      set({ products: s.original_products });
    }
  },

  changeProductsShippingPrice: (shippingPrice) => {
    return set((state) => ({
      ...state,
      products:
        state?.products?.length > 0 &&
        state?.products?.map((product) => ({
          ...product,
          shipping_price: shippingPrice,
        })),
    }));
  },
}));
